'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    width: 12px;\n    height: 12px;\n    transform: ', ';\n  '], ['\n    width: 12px;\n    height: 12px;\n    transform: ', ';\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    width: 20px;\n    height: 20px;\n    transform: ', ';\n  '], ['\n    width: 20px;\n    height: 20px;\n    transform: ', ';\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    width: 28px;\n    height: 28px;\n    transform: ', ';\n  '], ['\n    width: 28px;\n    height: 28px;\n    transform: ', ';\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  position: absolute;\n  top: 2px;\n  left: 0px;\n  background: ', ';\n  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);\n  border-radius: 50%;\n  pointer-events: none;\n\n  ', ';\n  ', ';\n'], ['\n  position: absolute;\n  top: 2px;\n  left: 0px;\n  background: ', ';\n  box-shadow: 0 2px 4px 0 rgba(0, 35, 11, 0.2);\n  border-radius: 50%;\n  pointer-events: none;\n\n  ', ';\n  ', ';\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _polished = require('polished');

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Styles


var sizes = {
  small: (0, _styledComponents.css)(_templateObject, function (_ref) {
    var on = _ref.on;
    return 'translateX(' + (on ? 14 : 2) + 'px)';
  }),
  normal: (0, _styledComponents.css)(_templateObject2, function (_ref2) {
    var on = _ref2.on;
    return 'translateX(' + (on ? 20 : 2) + 'px)';
  }),
  large: (0, _styledComponents.css)(_templateObject3, function (_ref3) {
    var on = _ref3.on;
    return 'translateX(' + (on ? 26 : 2) + 'px)';
  })
};

var SwitchToggle = _styledComponents2.default.div(_templateObject4, _colors.white, (0, _polished.transitions)('transform .2s ease-in-out'), function (_ref4) {
  var size = _ref4.size;
  return sizes[size];
});

SwitchToggle.propTypes = {
  on: _propTypes2.default.number,
  size: _propTypes2.default.string
};
exports.default = SwitchToggle;